import { FDStack } from '@facet-wealth/design';
import React from 'react';
import PropTypes from 'prop-types';
import MetaLayoutFields from './MetaLayoutFields';

/**
 * MetaLayoutVertical returns the meta fields in a vertical layout.
 *
 * This is the preferred default layout for meta forms.
 *
 * @deprecated use MetaLayoutRemainingFields
 * @param resource {Resource}
 * @return {JSX.Element}
 */
export default function MetaLayoutVertical({ resource }) {
  return (
    <FDStack direction={'column'} alignItems={'stretch'} spacing={2}>
      <MetaLayoutFields resource={resource} />
    </FDStack>
  );
}
MetaLayoutVertical.propTypes = {
  resource: PropTypes.object.isRequired,
};
